import generateId from './utils/generate-id'
import getApi from './get-api'

const actionsQueue = [] // FIFO queue
const callbacks = {}
let loadedApi

const callAction = (action, params = {}) => {
  if (!loadedApi) {
    return new Promise(resolve => {
      actionsQueue.push([action, params, resolve])
    })
  }
  return new Promise(resolve => {
    const messageId = generateId()
    callbacks[messageId] = resolve
    getApi().then(api => {
      api.postMessage({
        receiver: 'Native',
        sender: 'HostedPaymentPage',
        messageId,
        action,
        params
      })
    })
  })
}

const flushActionsQueue = () => {
  while (actionsQueue.length) {
    const [action, params, callback] = actionsQueue.shift()
    callAction(action, params).then(callback)
  }
}

const init = () => {
  return getApi().then(api => {
    // @ts-ignore
    api.addReceiver('HostedPaymentPage', ({ messageId, params } = {}) => {
      if (typeof callbacks[messageId] === 'function') {
        callbacks[messageId](params)
      }
    })
    loadedApi = api
    // Important to run _after_ setting loaded API, otherwise
    // it will end up in an infinite loop where `callAction`
    // inside `while` will re-queue the shifted actions
    // again because `loadedApi` is not set, and so on.
    flushActionsQueue()
  })
}

export {
  // Export for test purposes
  actionsQueue,
  callbacks
}

export default {
  init,
  callAction
}
